import { render, staticRenderFns } from "./MousePositionPlugin.vue?vue&type=template&id=5382ce7a&scoped=true"
import script from "./MousePositionPlugin.vue?vue&type=script&lang=ts"
export * from "./MousePositionPlugin.vue?vue&type=script&lang=ts"
import style0 from "./MousePositionPlugin.vue?vue&type=style&index=0&id=5382ce7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382ce7a",
  null
  
)

export default component.exports